module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/brook-671.e4adb804c8862d2c.jpg"+" 671w",
        images: [{path: "https://static.sniffspot.com/packs/img/brook-671.e4adb804c8862d2c.jpg",width: 671,height: 335}],
        src: "https://static.sniffspot.com/packs/img/brook-671.e4adb804c8862d2c.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/brook-671.e4adb804c8862d2c.jpg"},
        
        width: 671,
        height: 335
      }